import { tns } from "tiny-slider";

window.bindTnsSliders = function () {
  document
    .querySelectorAll("*[data-tns-options]:not(.tns-slider)")
    .forEach((slider) => {
      tns(JSON.parse(slider.getAttribute("data-tns-options")));
    });
};

window.addEventListener("DOMContentLoaded", () => {
  window.bindTnsSliders();
});
